import * as actionType from './actionType'

export const setLanguage = (lang,dir)=> ({
    type: actionType.SET_LANGUAGE,
    payload: {lang,dir}
})